import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["loader", "LoadingComponent"],
  _excluded2 = ["loader", "LoadingComponent", "componentProps"];
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Creates a wrapper for Loadable that will re-throw errors from the loaded component so we can catch it with our own ErrorBoundary
 */
export const makeLoadable = _ref => {
  let {
      loader,
      LoadingComponent
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return Loadable(Object.assign({
    loader,
    LoadingComponent,
    ErrorComponent: ({
      error
    }) => {
      throw error;
    }
  }, rest));
};

/**
 * A wrapper for Loadable that will pass common props from a common prop hook to both the loading and loaded component
 *
 * @param loader The loader for the full component
 * @param LoadingComponent The component for the loading state
 * @param componentProps Props to be passed to the loading and loaded component for both the loading and loaded component.
 * @param rest The rest of the props to pass to Loadable
 */
export const LoadableWrapper = _ref2 => {
  let {
      loader,
      LoadingComponent,
      componentProps
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const ComponentLoadable = useMemo(() => makeLoadable(Object.assign({
    loader,
    LoadingComponent: () => LoadingComponent ? /*#__PURE__*/_jsx(LoadingComponent, Object.assign({}, componentProps || {})) : null
  }, rest)),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  return /*#__PURE__*/_jsx(ComponentLoadable, Object.assign({}, componentProps));
};
export default LoadableWrapper;